import { AxiosResponse } from "axios";
import { MutationBasicaParam, QueryBasicaParam } from "../../../../Utils/RequisicaoUtilitario";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";
import Pagamento from "@/Models/Financeiro/Titulo/Pagamento/Pagamento";
import { queryClient } from "@/App";

export function usePagamentoListar({
    codTitulo,
    queryKey,
    ...rest
}:QueryBasicaParam<AxiosResponse<Pagamento[]>, Pagamento[], {
    codTitulo:number;
}>) {    
    return useQuery({
        ...rest,
        queryKey : [ "Financeiro.Titulo.Pagamento.Listar", `Financeiro.Titulo.${codTitulo}.Pagamento.Listar` ],
        queryFn : () => Axios.get<Pagamento[]>(`financeiro/titulo/${codTitulo}/pagamento`),
        select : (response) => {
            return response.data;
        }
    });
}

export function usePagamentoListarPorTitulo({
    codTitulo,
    queryKey,
    ...rest
}:QueryBasicaParam<AxiosResponse<Pagamento[]>, Pagamento[], {
    codTitulo:number;
}>) {    
    return useQuery({
        ...rest,
        queryKey : [ "Financeiro.Titulo.Pagamento.PorTitulo.Listar", `Financeiro.Titulo.${codTitulo}.Pagamento.PorTitulo.Listar` ],
        queryFn : () => Axios.get<Pagamento[]>(`financeiro/titulo/${codTitulo}/pagamento/por-titulo`),
        select : (response) => {
            return response.data;
        }
    });
}

export function usePagamentoListarPorFatura({
    codFatura,
    queryKey,
    ...rest
}:QueryBasicaParam<AxiosResponse<Pagamento[]>, Pagamento[], {
    codFatura:number;
}>) {    
    return useQuery({
        ...rest,
        queryKey : [ "Financeiro.Titulo.Pagamento.PorFatura.Listar", `Financeiro.Titulo.${codFatura}.Pagamento.PorFatura.Listar` ],
        queryFn : () => Axios.get<Pagamento[]>(`financeiro/titulo/${codFatura}/pagamento/por-fatura`),
        select : (response) => {
            return response.data;
        }
    });
}

export function useTituloPagamentoDesativar({
    onSuccess,
    ...rest
}:MutationBasicaParam<Pagamento, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (entrada) => {
            return Axios.patch<void>(`financeiro/titulo/${entrada.codTitulo}/pagamento/desativar`, entrada);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ['Financeiro.Titulo.Pagamento.Listar', `Financeiro.Titulo.${entrada.codTitulo}.Pagamento.Listar`] })

            onSuccess?.(retorno, entrada, context);
        }
    });
}


export function useTituloPagamentoInfoCancelamento({
    onSuccess,
    ...rest
}:MutationBasicaParam<Pagamento, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (entrada) => {
            return Axios.patch<void>(`financeiro/titulo/${entrada.codTitulo}/pagamento/info-cancelamento`, entrada);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ['Financeiro.Titulo.Pagamento.Listar', `Financeiro.Titulo.${entrada.codTitulo}.Pagamento.Listar`] })

            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useTituloPagamentoInserir({
    onSuccess,
    ...rest
}:MutationBasicaParam<Pagamento, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (entrada) => {
            return Axios.post<void>(`financeiro/titulo/${entrada.codTitulo}/pagamento`, entrada);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ['Financeiro.Titulo.Pagamento.Listar', `Financeiro.Titulo.${entrada.codTitulo}.Pagamento.Listar`] })

            onSuccess?.(retorno, entrada, context);
        }
    });
}